const layoutFileTypes = [
  { name: 'PDF', field: 'pdfUrl' },
  { name: 'OFD', field: 'ofdUrl' },
  { name: 'XML', field: 'xmlUrl' }
]

export const getLayoutFileActions = (invoice = {}) => {
  return layoutFileTypes.filter(item => invoice[item.field])
}

export const hasLayoutFile = (invoice = {}) => {
  return getLayoutFileActions(invoice).length > 0
}

export const isCrossOriginUrl = (url, currentOrigin) => {
  if (!url || !currentOrigin) {
    return false
  }
  try {
    return new URL(url, currentOrigin).origin !== new URL(currentOrigin).origin
  } catch (error) {
    return false
  }
}
